import { Button } from "shared";
import type { ILegalListFilter } from "entities/template";
import React, { useState } from "react";
import { useComponentsTranslations } from "../../../../../lib/i18n";
import { LegalCompanyListFilter } from "../list_filter/list_filter";
import styles from "./bank_details_filter_modal.module.scss";

interface IBankDetailsFilterModalProps {
    close: () => void;
    initialValue: ILegalListFilter;
    onSave: (value: ILegalListFilter) => void;
}

export const BankDetailsFilterModal: React.FC<IBankDetailsFilterModalProps> = React.memo(
    ({ close, initialValue, onSave }) => {
        const t = useComponentsTranslations();
        const [draft, setDraft] = useState<ILegalListFilter>(initialValue);

        const onSaveClick = () => {
            onSave(draft);
            close();
        };

        return (
            <div className={styles.container}>
                <LegalCompanyListFilter value={draft} onChange={setDraft} />
                <div className={styles.buttonGroup}>
                    <Button view="legal" type="button" onClick={onSaveClick}>
                        {t("save")}
                    </Button>
                </div>
            </div>
        );
    }
);
